import { render } from "./dotted-list.vue?vue&type=template&id=8c7e869a"
const script = {}

import "./dotted-list.vue?vue&type=style&index=0&id=8c7e869a&lang=scss"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__